// @core/api/endpoints/secret/verify.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  VerifyRequest,
  VerifyResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Verify signature
 * Verifies a signature against input data using the named key. Returns whether the signature is valid.
 */
export async function Verify(
  engine_id: string,
  key_name: string,
  data: VerifyRequest,
  options?: RequestOptions
): Promise<VerifyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/transit/verify/:key_name`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':key_name', encodeURIComponent(key_name));
  const requestOptions = options;
  return client.post<VerifyResponse>(requestPath, data, requestOptions);
}
